export type FreightTypeMessages = {
  freightTypeNoFreightLabel: string;
  freightTypeNoFreightDescription: string;

  freightTypeOwnFreightTableLabel: string;
  freightTypeOwnFreightTableDescription: string;

  freightTypeAutomatedFreightTableLabel: string;
  freightTypeAutomatedFreightTableDescription: string;
};

export const FREIGHT_TYPE_MESSAGES: FreightTypeMessages = {
  freightTypeNoFreightLabel: "Não utilizar",
  freightTypeNoFreightDescription:
    "Nesse caso a plataforma Talk2buy não irá validar o CEP do cliente, seja para avaliar a área de abrangência ou calcular fretes.",

  freightTypeOwnFreightTableLabel: "Utilizar com tabela de frete própria",
  freightTypeOwnFreightTableDescription:
    "Nesse caso a plataforma Talk2buy irá validar se o CEP do cliente está cadastrado na área de abrangência, caso esteja o processo de venda seguirá normalmente, caso contrário, o cliente será informado que infelizmente não atuamos naquela área. Caso queira controlar áreas de abrangência e não cobrar fretes, basta deixar os valores de frete em branco.",

  freightTypeAutomatedFreightTableLabel: "Utilizar com tabela de frete automatizada",
  freightTypeAutomatedFreightTableDescription:
    "Nesse caso a plataforma Talk2buy irá validar se o CEP do cliente está cadastrado na área de abrangência, caso esteja o processo de venda seguirá normalmente, caso contrário, o cliente será informado que infelizmente não atuamos naquela área. Nesse cenário, os valores de frete, assim como as etiquetas de despacho, serão gerados automaticamente através do nosso parceiro de logística.",
};
// no default export
